import * as SalesOrderStore from './SalesOrderStore';

import { Command } from 'pos/common';
import { Result, SessionProvider } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Permission, SalesOrderDTO, Res } from 'core/api';
import { Message } from 'core/ui-next/modal';

async function allowCashTransaction(): Promise<boolean> {
	if (SessionProvider.getCurrent().AllowCashTransactions)
		return true;

	await Message.show(Res.Msg.MSG_CURRENT_POS_DOES_NOT_ALLOW_CASH_TRANSACTIONS());
	return false;
}

declare global {
	interface CommandType {
		cancelSalesOrder: (salesOrder: SalesOrderDTO, allowCancelWithPreviousPayments: boolean) => Promise<Result>
	}
}

Command.register('cancelSalesOrder', Preconditions.and(Preconditions.ensure(Permission.SalesOrder_Cancel), Preconditions.ensureIsNotLite), async (salesOrder: SalesOrderDTO, allowCancelWithPreviousPayments: boolean): Promise<Result> => {
	if (!await allowCashTransaction())
		return Result.error();

	if (!allowCancelWithPreviousPayments && salesOrder.PrepaidAmount !== 0) {
		await Message.show(Res.Msg.MSG_CANNOT_CANCEL_A_SALES_ORDER_WITH_BALANCE_OTHER_THAN_ZERO());
		return Result.error();
	}

	const confirmCancel = await Message.confirm(Res.Msg.MSG_CONFIRM_CANCEL_SALES_ORDER());
	if (!confirmCancel.ok)
		return Result.ok();

	await SalesOrderStore.cancel(salesOrder.Id);
	return Result.ok();
});